import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ToastContext = createContext(null);

let idCounter = 1;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, { type = 'info', duration = 4000 } = {}) => {
    const id = idCounter++;
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => {
      setToasts((t) => t.filter((x) => x.id !== id));
    }, duration);
  }, []);

  const value = useMemo(() => ({
    showInfo: (msg, opts) => show(msg, Object.assign({}, opts, { type: 'info' })),
    showSuccess: (msg, opts) => show(msg, Object.assign({}, opts, { type: 'success' })),
    showError: (msg, opts) => show(msg, Object.assign({}, opts, { type: 'error' })),
  }), [show]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed left-0 right-0 bottom-6 flex justify-center pointer-events-none z-50">
        <div className="w-full max-w-lg px-4 pointer-events-auto">
          <div className="space-y-2">
            {toasts.map((t) => (
              <div key={t.id} className={`px-4 py-2 rounded shadow-md text-sm text-white ${t.type === 'error' ? 'bg-red-600' : t.type === 'success' ? 'bg-green-600' : 'bg-gray-800'}`}>
                {t.message}
              </div>
            ))}
          </div>
        </div>
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within ToastProvider');
  return ctx;
}
